import React from 'react';
import { Link } from 'react-router-dom';
import { directAppointmentList } from '../constants/directAppointments';
import { getUserSession, isValidSession } from '../services/authService';
import '../styles/services.css';

const ServiceDirectAppointmentsPage = () => {
  const sessionUser = getUserSession();
  const isLoggedIn = isValidSession(sessionUser);

  return (
    <div className="services-root">
      <section className="services-section services-section-intro">
        <div className="services-hero-card">
          <h1 className="services-hero-title">Citas en Directo</h1>
          <p className="services-hero-text">
            Elige la modalidad de atención que mejor se adapte a ti. Contamos con terapias online,
            atención presencial personalizada y acompañamiento desde tu celular, siempre guiado por
            profesionales.
          </p>
        </div>
      </section>

      {!isLoggedIn ? (
        <section className="services-section">
          <div className="therapies-notice">
            <p className="therapies-notice-text">
              Debes registrarte para poder utilizar cualquier tipo de servicio.
            </p>
            <Link to="/registro" className="therapies-notice-button">
              Registrarme
            </Link>
          </div>
        </section>
      ) : null}

      <section className="services-section services-section-catalog">
        <div className="appointments-grid">
          {directAppointmentList.map((item) => (
            <article key={item.id} className="appointments-card">
              <div className="appointments-card-logo">
                <img
                  src={`${process.env.PUBLIC_URL}/images/${item.image}`}
                  alt={item.imageAlt}
                  className="appointments-card-logo-img"
                />
              </div>
              <p className="appointments-card-brand">{item.brand}</p>
              <h2 className="appointments-card-title">{item.title}</h2>
              <p className="appointments-card-description">{item.description}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServiceDirectAppointmentsPage;
